import {GlobalServiceProvider} from "../../providers/global.service";


export interface CommandActionInterface{

  componentName:string;
  commandString:string;
  global:GlobalServiceProvider;

  do(commandString?):any;
  getResult():any;
  destroy():void;


}

export class CommandActionBase{

  public params;
  public static getNew(){
  }

}



// WEBPACK FOOTER //
// ./src/components/commands/command-action.ts